import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import App from './App.tsx';

if (window.location.pathname === '/rules') {
	window.location.replace('https://www.youtube.com/watch?v=Ki1DJEGKkzM');
}

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<App />
	</StrictMode>
);
